import { Field } from "sparkson";

export class Subtitle {
  constructor(
    @Field("s") public source: string,
    @Field("l", true) public label?: string,
  ) {}
}
